import { Box, VStack } from "@chakra-ui/react";
import WaitList from "../../components/ResultLists/WaitList";

export default function CompleteTab({ list }) {
  return (
    <VStack spacing="4" w="100%">
      {list?.length > 0 ? (
        list.map((item, i) => (
          <Box w="100%" key={item.campaignId}>
            <WaitList item={item} />
          </Box>
        ))
      ) : (
        <div>검색 결과가 없습니다.</div>
      )}
    </VStack>
  );
}
